export interface IdAware {
  id: string;
}

export type StringId<T> = Omit<T, "id"> & { id: string };

export const isEqualById = <T extends { id?: unknown }>(a: T | null | undefined, b: T | null | undefined) => a === b || a?.id === b?.id;
